<template>
    <rkm-modal
        extraLarge
        ref="RkmModal"
        title="Reagendar coletas não realizadas"
        :buttons="['cancel']"
    >
        <rkm-row>
            <rkm-col>

                <Form
                    :itemsNotRealizados="itemsNotRealizados"
                    :data="data"
                    @exit="exit"
                    origem="coleta"
                />
            </rkm-col>
        </rkm-row>
    </rkm-modal>
</template>

<script>

import Form from './Form'

export default {
    components: { Form },
    data: () => ({
        item: null
    }),
    methods: {
        open() {

            this.$refs.RkmModal.show()
        },
        exit() {

            this.$refs.RkmModal.hide()
        },
        handleCancel() {

            this.resetForm()
            this.$refs.RkmModal.hide()
        },
    },
    props: {
        data: { type: Object, required: true },
        itemsNotRealizados: { type: Array, required: true }
    },
}
</script>

